import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateApplicationState from './app';

export default (state = initialState, action) => chooseReducer(state, action, updateApplicationState);
